import { render } from "./ProjectPanel.vue?vue&type=template&id=25b47661&scoped=true"
import script from "./ProjectPanel.vue?vue&type=script&lang=js"
export * from "./ProjectPanel.vue?vue&type=script&lang=js"

import "./ProjectPanel.vue?vue&type=style&index=0&id=25b47661&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b47661"]])

export default __exports__